import * as React from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { StoreState } from "../../reducers/root-reducer";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import { translate, InjectedTranslateProps } from "react-i18next";

import {
	setDate,
	openAddReservationDialog,
	activateTableLinkMode,
	activateTableLinkDeletionMode
} from "../../actions/store/app-actions";

import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import LayersIcon from "@material-ui/icons/Layers";
import {
	showAdditionalInfo,
	hideAdditionalInfo,
	toggleInfoBar,
	setActiveArea
} from "../../actions/store/overview-actions";
import { Area } from "../../api/areas";

export interface AreaSelectProps {}

interface State {
	areaSelectAnchor: HTMLElement;
	activeAreaName: string;
}

interface ConnectedAreaSelectProps extends WithStyles<typeof styles> {
	areas: Area[];
	activeAreaId: string;
	layout: "desktop" | "tablet" | "phone";
	setActiveArea: (id: string) => void;
}

type Props = AreaSelectProps &
	ConnectedAreaSelectProps &
	InjectedTranslateProps;

export class AreaSelect extends React.Component<Props, State> {
	public state: State = {
		areaSelectAnchor: null,
		activeAreaName: null
	};

	componentDidMount() {
		this.setActiveAreaName(this.props.activeAreaId);
	}

	componentWillReceiveProps(nextProps: Props) {
		if (this.props.activeAreaId !== nextProps.activeAreaId) {
			this.setActiveAreaName(nextProps.activeAreaId);
		}
	}

	setActiveAreaName = (id: string) => {
		const { areas } = this.props;

		const activeArea = areas.find(area => area.id === id);

		if (activeArea) {
			this.setState({
				activeAreaName: activeArea.name
			});
		}
	};

	handleAreaSelectClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		this.setState({ areaSelectAnchor: event.currentTarget });
	};

	handleAreaSelectClose = () => {
		this.setState({ areaSelectAnchor: null });
	};

	handleAreaChange = (
		event: React.ChangeEvent<HTMLSelectElement>,
		value: string
	) => {
		this.props.setActiveArea(value);
	};

	handleAreaSelectItemClick = (id: string) => {
		this.props.setActiveArea(id);
	};
	public render() {
		const { classes, areas, layout } = this.props;
		const { activeAreaName, areaSelectAnchor } = this.state;

		return (
			<React.Fragment>
					<Button
						className={classes.dropdownButton}
						variant={layout === "phone" ? "flat" : "outlined"}
						color="inherit"
						onClick={this.handleAreaSelectClick}
					>
						<LayersIcon className={classes.iconSmall} />
						<span className={classes.iconButtonLabel}>
							{activeAreaName}
						</span>
					</Button>
				<Menu
					anchorEl={areaSelectAnchor}
					open={Boolean(areaSelectAnchor)}
					onClick={this.handleAreaSelectClose}
				>
					{areas.map(area => (
						<MenuItem
							key={area.id}
							onClick={() =>
								this.handleAreaSelectItemClick(area.id)
							}
						>
							{area.name}
						</MenuItem>
					))}
				</Menu>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({
	areas: state.areas,
	activeAreaId: state.overviewActiveAreaId,
	layout: state.layout
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	setActiveArea: (id: string) => dispatch(setActiveArea(id))
});

const styles = (theme: Theme) =>
	createStyles({
		iconSmall: {
			fontSize: 20
		},
		iconButtonLabel: {
			textTransform: "none",
			paddingLeft: 6,
			paddingRight: 6
		},
		dropdownButton: {
			paddingLeft: 8,
			paddingRight: 8,
			borderColor: "rgba(255, 255, 255, 0.3)"
		},
		areaSelect: {}
	});

export const ConnectedAreaSelect = translate("translations")(
	withStyles(styles)(
		connect(
			mapStateToProps,
			mapDispatchToProps
		)(AreaSelect)
	)
);
